import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Powiadomienie o plikach cookie",
    description:
      "Używamy niezbędnych plików cookie, aby zapewnić prawidłowe działanie tej witryny. Używamy również opcjonalnych plików cookie śledzących, aby pomóc nam zrozumieć, w jaki sposób korzystasz z naszej strony. Te opcjonalne pliki cookie zostaną ustawione tylko za Twoją zgodą.",
    acceptAllBtn: "Akceptuj wszystkie",
    acceptNecessaryBtn: "Odrzuć wszystkie",
    showPreferencesBtn: "Zarządzaj indywidualnymi preferencjami",
  },
  preferencesModal: {
    title: "Zarządzaj preferencjami plików cookie",
    acceptAllBtn: "Akceptuj wszystkie",
    acceptNecessaryBtn: "Odrzuć wszystkie",
    savePreferencesBtn: "Akceptuj bieżący wybór",
    closeIconLabel: "Zamknij okno",
    sections: [
      {
        title: "Użycie plików cookie",
        description:
          "Używamy plików cookie, aby wspierać podstawowe funkcje tej witryny i poprawić Twoje wrażenia z przeglądania.",
      },
      {
        title: "Ściśle niezbędne pliki cookie",
        description:
          "Te pliki cookie są niezbędne do prawidłowego funkcjonowania witryny, na przykład do uwierzytelniania użytkowników.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Nazwa",
            domain: "Usługa",
            description: "Opis",
            expiration: "Wygaśnięcie",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Plik cookie ustawiony przez Platformę Społeczności Cyfrowej do uwierzytelniania użytkowników.",
              expiration: "Sesja",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Plik cookie ustawiony przez Platformę Społeczności Cyfrowej do uwierzytelniania użytkowników",
              expiration: "Sesja",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Ten plik cookie jest używany do rozróżniania ludzi i robotów, aby chronić witrynę przed zautomatyzowanym nadużyciem. Żadne dane osobowe nie są zbierane.",
              expiration: "30 minut",
            },
          ],
        },
      },
      {
        title: "Analityka",
        description:
          "Pliki cookie używane do analityki pomagają zbierać dane, które pozwalają usługom zrozumieć, w jaki sposób użytkownicy wchodzą w interakcję z daną usługą. Te informacje umożliwiają poprawę treści i tworzenie lepszych funkcji, które zwiększają doświadczenie użytkownika.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Nazwa",
            domain: "Usługa",
            description: "Opis",
            expiration: "Wygaśnięcie",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Plik cookie ustawiony przez <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Wygasa po 12 dniach",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Plik cookie ustawiony przez <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Sesja",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Włącza przechowywanie danych analitycznych, np. czasu trwania wizyty.";

export { translation, servicesLabel };
